/* unplugin-vue-components disabled */import __unplugin_components_3 from 'D:/workspace/space-time-web/src/components/TreeSelect/index.vue';
import __unplugin_components_2 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/DictTag/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  class: "head-container"
};
const _hoisted_5 = {
  class: "head-container"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "value"
};
const _hoisted_8 = {
  class: "link"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
const _hoisted_10 = {
  class: "el-upload__tip text-center"
};
const _hoisted_11 = {
  class: "el-upload__tip"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
const _hoisted_13 = {
  style: {
    "width": "80rem",
    "height": "60rem",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0",
    "margin": "auto"
  }
};
const _hoisted_14 = {
  key: 0,
  style: {
    "width": "100%",
    "height": "60rem",
    "background": "#12213B",
    "text-align": "center",
    "line-height": "60rem",
    "font-size": "2.4rem",
    "color": "#3f95ff"
  }
};
const _hoisted_15 = {
  class: "dialog-footer"
};
const _hoisted_16 = {
  class: "my-header"
};
const _hoisted_17 = ["id"];
import { getToken } from "@/utils/auth";
import { treeselect } from "@/api/system/dept";
import { getDeviceList, getInfo, addDevice, updateDevice, delDevice, deviceVideoPlay, exportDevice, getTreeselectUserList, getDevicePushInfo } from "@/api/base/device";
import { getSdpTerminalInfo, getSdpTerminalStatus } from "@/api/device/device";
import player from "@/components/jessibuca/index.vue";
import tdtmap from "@/components/TdtMap/index.vue";
import editfield from "./editfield";
import instructions from "./instructions";
import deviceflat from "./deviceflat";
import { getDicts } from "@/api/system/dict/data";
import { queryFieldTemplate } from '@/api/base/fieldTemplate';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const {
      device_type,
      device_status
    } = proxy.useDict("device_type", "device_status");
    const loading = ref(true);
    const ids = ref([]);
    const devicesOptions = ref([]);
    const single = ref(true);
    const multiple = ref(true);
    const showSearch = ref(true);
    const total = ref(0);
    const deviceList = ref([]);
    const title = ref("");
    const open = ref(false);
    const dialogMapAddress = ref(false);
    const titleview = ref("");
    const openview = ref(false);
    const defaultSort = ref({
      prop: 'status',
      order: 'descending'
    });
    const deptOptions = ref(undefined);
    const userList = ref([]);
    const sdpData = reactive({
      terminalData: {},
      openData: false,
      lastTerminalId: ''
    });
    /*** 设备导入参数 */
    const upload = reactive({
      // 是否显示弹出层（设备导入）
      open: false,
      // 弹出层标题（设备导入）
      title: "",
      // 是否禁用上传
      isUploading: false,
      // 是否更新已经存在的设备数据
      updateSupport: 0,
      // 设置上传的请求头部
      headers: {
        Authorization: "Bearer " + getToken()
      },
      // 上传的地址
      url: process.env.VUE_APP_BASE_API + "/device/importData"
    });
    const deviceType = ref("");
    const deviceTypeName = ref(undefined);
    const deptName = ref("");
    const video = ref({
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      title: '',
      // 视频流的地址
      url: null
    });
    const data = reactive({
      form: {
        fieldTemplateList: []
      },
      formview: {
        fieldTemplateList: []
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        flatName: undefined,
        model: undefined,
        ownerUser: undefined,
        deviceType: "",
        deptId: undefined
      },
      rules: {
        name: [{
          required: true,
          message: '设备名称不能为空',
          trigger: 'blur'
        }],
        deptId: [{
          required: true,
          message: '归属部门不能为空',
          trigger: 'blur'
        }]
      }
    });
    const {
      queryParams,
      form,
      formview,
      rules
    } = toRefs(data);
    const satelliteMasterStationOptions = ref([{
      label: '无',
      value: ''
    }, {
      label: 'KA',
      value: '10.168.88.5'
    }, {
      label: 'KU',
      value: '10.193.38.209'
    }]);

    /** 通过条件过滤节点  */
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    /** 根据名称筛选部门树 */
    watch(deptName, val => {
      proxy.$refs["deptTreeRef"].filter(val);
    });
    watch(queryParams.value.deviceType, newValue => {
      deviceType.value = newValue;
    });
    function selectCurrentType() {
      deviceType.value = queryParams.value.deviceType;
      deviceTypeName.value = proxy.selectDictLabel(device_type.value, queryParams.value.deviceType);
      getList();
    }

    /** 查询部门下拉树结构 */
    function getTreeselect() {
      treeselect().then(response => {
        deptOptions.value = response.data;
      });
      getTreeselectUserList().then(response => {
        userList.value = response.data;
      });
      getDicts("device_type").then(response => {
        devicesOptions.value = [];
        response.data.forEach(item => {
          if (item.dictValue !== "12") {
            devicesOptions.value.push(item);
          }
        });
      });
    }
    ;

    /** 查询设备列表 */
    function getList() {
      loading.value = true;
      getDeviceList(queryParams.value).then(res => {
        loading.value = false;
        deviceList.value = res.rows;
        total.value = res.total;
      });
    }
    ;
    function selectable(row, index) {
      return row.deviceType !== "12"; //为true的时候可以选，为false则不可选择
    }
    const querySearch = (queryString, cb) => {
      if (queryString.length < 3) return cb([]);
      getSdpTerminalInfo(queryString).then(res => {
        cb(res.data);
        console.log(res);
      });
    };
    const handleSelect = item => {
      form.value.terminalId = item.terminalId;
    };
    const showTerminal = terminalId => {
      if (!terminalId) {
        terminalId = form.value.terminalId;
      } else if (terminalId === 'last') {
        terminalId = sdpData.lastTerminalId;
      }
      if (terminalId === '') {
        proxy.$modal.msgWarning("未设置卫星天线的端站点ID，请去设备管理页面设置");
      } else {
        sdpData.terminalData = {};
        getSdpTerminalStatus(terminalId).then(res => {
          if (res.code === 200) {
            sdpData.lastTerminalId = terminalId;
            sdpData.terminalData = res.data;
            sdpData.openData = true;
          } else {
            proxy.$modal.msgWarning("查询卫星天线信息失败，请检查端站点ID设置是否正确");
          }
          console.log(res);
        });
      }
    };
    function getSdpInfo(name) {
      getSdpTerminalInfo(name).then(res => {
        console.log(res);
      });
    }

    /** 节点单击事件 */
    function handleNodeClick(data) {
      queryParams.value.deptId = data.id;
      handleQuery();
    }
    ;

    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }
    ;

    /** 重置按钮操作 */
    function resetQuery() {
      proxy.resetForm("queryRef");
      proxy.$refs["ownerUserTreeRef"].clearHandle();
      proxy.$refs["devicetableRef"].sort(defaultSort.value.prop, defaultSort.value.order);
      handleQuery();
    }
    ;

    /** 排序触发事件 */
    function handleSortChange(column, prop, order) {
      queryParams.value.orderByColumn = column.prop;
      queryParams.value.isAsc = column.order;
      getList();
    }
    function goTree() {
      if (deviceType.value === '') {
        proxy.$modal.msgWarning("请先选择设备类型再进自定义字段设置");
        return;
      }
      proxy.$refs["editfieldRef"].show(deviceType.value);
    }
    function closeMapaddressDialog() {
      dialogMapAddress.value = false;
    }
    // 获取详细地址
    function setAddress(val) {
      //console.log("这是 获取详细地址 val", val);
      if (val) {} else {
        proxy.$modal.msgWarning("未定位到详细地址请手动输入");
      }
    }
    // 获取经纬度
    function setPosition(val) {
      //console.log("这是 获取经纬度 val", val);
      if (val.length && val.length == 2) {
        form.value.longitude = val[0];
        form.value.latitude = val[1];
      } else {
        proxy.$modal.msgWarning("未定位到经纬度坐标请手动输入");
      }
    }
    function openMapAddressDialog() {
      dialogMapAddress.value = true;
    }
    function showItemLabel(type, map, value) {
      var label = "";
      if (type === 5 && map !== undefined && value !== undefined) {
        map.map(item => {
          if (value === item.value) {
            label = item.label;
          }
        });
      } else if (type === 6 && map !== undefined && value !== undefined) {
        value.map(item1 => {
          map.map(item => {
            if (item1 === item.value) {
              label += item.label + " ";
            }
          });
        });
      }
      return label;
    }
    function handleView(row) {
      formview.value = {};
      getInfo(row.id).then(response => {
        formview.value = response.data;
        openview.value = true;
        titleview.value = formview.value.name;
      });
    }

    /** 删除按钮操作 */
    function handleDelete(row) {
      const deviceIds = row.id || ids.value;
      const names = proxy.getNames(deviceIds, deviceList.value, "id", "name");
      proxy.$modal.confirm('是否确认删除设备名称为"' + names + '"的数据项?').then(function () {
        return delDevice(deviceIds);
      }).then(res => {
        if (res.data !== undefined && res.data.length > 0) {
          res.data.forEach(item => {
            const devicenames = proxy.getNames(item.aircraft, deviceList.value, "id", "name");
            proxy.$modal.msgWarning("删除失败, 设备" + devicenames + "已关联在" + item.taskName + "任务");
          });
        } else {
          proxy.$modal.msgSuccess("删除成功");
        }
        getList();
      }).catch(() => {});
    }
    ;

    /** 导出按钮操作 */
    function handleExport() {
      proxy.download("device/export", {
        ...queryParams.value
      }, `device_${new Date().getTime()}.xlsx`);
    }
    ;
    function handlePdfManager(row) {
      proxy.$refs["instructionsRef"].show(row.id);
    }

    /** 设备播放 */
    function handleDevicePlayManager(row) {
      /*console.log(row)*/
      deviceVideoPlay({
        deviceName: row.deviceName,
        channelId: row.channelId,
        deviceType: row.deviceType
      }).then(response => {
        video.value.open = true;
        video.value.title = '测试连接';
        if (response.code === 200 && response.msg === '操作成功') {
          video.value.url = response.data.wss_flv;
        } else {
          video.value.url = "";
        }
      });
      /*  getDevicePushInfo(row.streamName).then(res=>{
          console.log(res)
        })*/
    }

    // 关闭窗口
    function closeDialog() {
      video.value.title = '';
      video.value.url = "";
      video.value.open = false;
    }
    function destroy() {
      proxy.$refs["playerRef"].destroy();
    }

    /** 设备关联 */
    function handleDeviceFlatManager(row) {
      proxy.$refs["deviceflatRef"].show(row.id, row.deviceType);
    }

    /** 关联载体 */
    function deviceFlatManager(row) {
      proxy.$refs["deviceflatRef"].show(row.parentId);
    }

    /** 选择条数  */
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.id);
      single.value = selection.length != 1;
      multiple.value = !selection.length;
    }
    ;

    /** 导入按钮操作 */
    function handleImport() {
      upload.title = "设备导入";
      upload.open = true;
    }
    ;

    /** 下载模板操作 */
    function importTemplate() {
      proxy.download("device/importTemplate", {}, `device_template_${new Date().getTime()}.xlsx`);
    }
    ;
    /**文件上传中处理 */
    const handleFileUploadProgress = (event, file, fileList) => {
      upload.isUploading = true;
    };
    /** 文件上传成功处理 */
    const handleFileSuccess = (response, file, fileList) => {
      upload.open = false;
      upload.isUploading = false;
      proxy.$refs["uploadRef"].handleRemove(file);
      proxy.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70rem;padding: 1rem 2rem 0;'>" + response.msg + "</div>", "导入结果", {
        dangerouslyUseHTMLString: true
      });
      getList();
    };

    /** 提交上传文件 */
    function submitFileForm() {
      proxy.$refs["uploadRef"].submit();
    }
    ;

    /** 初始化部门数据 */
    function initTreeData() {
      // 判断部门的数据是否存在，存在不获取，不存在则获取
      if (deptOptions.value === undefined) {
        treeselect().then(response => {
          deptOptions.value = response.data;
        });
      }
    }
    ;

    /** 重置操作表单 */
    function reset() {
      form.value = {
        name: undefined,
        deptId: undefined,
        model: undefined,
        longitude: undefined,
        latitude: undefined,
        highly: undefined,
        uid: undefined,
        status: "0",
        ownerUser: undefined,
        phoneNumber: undefined,
        productionTime: undefined,
        expirationTime: undefined,
        videoSource: undefined,
        deviceName: undefined,
        channelId: undefined,
        remark: undefined,
        fieldTemplateList: []
      };
      rules.value = {
        name: [{
          required: true,
          message: '设备名称不能为空',
          trigger: 'blur'
        }],
        deptId: [{
          required: true,
          message: '归属部门不能为空',
          trigger: 'blur'
        }]
      };
      proxy.resetForm("deviceRef");
    }
    ;

    /** 取消按钮 */
    function cancel() {
      open.value = false;
      reset();
    }
    ;
    function cancel1() {
      openview.value = false;
      formview.value = {};
      titleview.value = "";
    }
    ;

    /** 新增按钮操作 */
    function handleAdd() {
      if (deviceType.value === '') {
        proxy.$modal.msgWarning("请先选择设备类型再进行添加");
        return;
      }
      reset();
      initTreeData();
      queryFieldTemplate(deviceType.value).then(res => {
        form.value.fieldTemplateList = res.data.fieldTemplateList;
        if (form.value.fieldTemplateList.length > 0) {
          form.value.fieldTemplateList.map(item => {
            if (item.required) {
              rules.value[item.field] = [{
                required: true,
                message: item.label + '不能为空',
                trigger: 'blur'
              }];
            }
          });
        }
        form.value.deviceType = deviceType.value;
      });
      if (deviceType.value === "0") {
        rules.value.uid = [{
          required: true,
          message: '设备UID不能为空',
          trigger: 'blur'
        }];
      }
      if (deviceType.value === "4" || deviceType.value === "5") {
        rules.value.deviceName = [{
          required: true,
          message: '设备编码不能为空',
          trigger: 'blur'
        }];
        rules.value.channelId = [{
          required: true,
          message: '设备通道不能为空',
          trigger: 'blur'
        }];
      }
      getInfo().then(response => {
        open.value = true;
        title.value = '添加' + deviceTypeName.value;
      });
    }
    ;

    /** 修改按钮操作 */
    function handleUpdate(row) {
      const curDeviceType = row.deviceType;
      reset();
      initTreeData();
      queryFieldTemplate(curDeviceType).then(res => {
        form.value.fieldTemplateList = res.data.fieldTemplateList;
        if (form.value.fieldTemplateList.length > 0) {
          form.value.fieldTemplateList.map(item => {
            if (item.required) {
              rules.value[item.field] = [{
                required: true,
                message: item.label + '不能为空',
                trigger: 'blur'
              }];
            }
          });
        }
        form.value.deviceType = curDeviceType;
      });
      if (curDeviceType === "0") {
        rules.value.uid = [{
          required: true,
          message: '设备UID不能为空',
          trigger: 'blur'
        }];
      }
      if (curDeviceType === "4" || curDeviceType === "5") {
        rules.value.deviceName = [{
          required: true,
          message: '设备编码不能为空',
          trigger: 'blur'
        }];
        rules.value.channelId = [{
          required: true,
          message: '设备通道不能为空',
          trigger: 'blur'
        }];
      }
      const id = row.id || ids.value;
      getInfo(id).then(response => {
        form.value = response.data;
        if (form.value.fieldTemplateList.length > 0) {
          form.value.fieldTemplateList.map(item => {
            if (item.value !== undefined) {
              form.value[item.field] = item.value;
            }
          });
        }
        open.value = true;
        title.value = "修改" + form.value.name;
      });
    }
    ;

    /** 提交按钮 */
    function submitForm() {
      proxy.$refs["deviceRef"].validate(valid => {
        if (valid) {
          if (form.value.fieldTemplateList.length > 0) {
            form.value.fieldTemplateList = form.value.fieldTemplateList.map((item, index) => {
              if (form.value[item.field] !== null && form.value[item.field] !== undefined && form.value[item.field] !== "") {
                item.value = form.value[item.field];
              }
              return item;
            });
          }
          if (form.value.id != undefined) {
            updateDevice(form.value).then(response => {
              if (response.msg !== "操作成功") {
                proxy.$modal.msgWarning(response.msg);
              } else {
                proxy.$modal.msgSuccess("修改成功");
                cancel();
                getList();
              }
            });
          } else {
            addDevice(form.value).then(response => {
              if (response.msg !== "操作成功") {
                proxy.$modal.msgWarning(response.msg);
              } else {
                proxy.$modal.msgSuccess("新增成功");
              }
              cancel();
              getList();
            });
          }
        }
      });
    }
    ;
    getTreeselect();
    getList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_dict_tag = __unplugin_components_1;
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_2;
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_tree_select = __unplugin_components_3;
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_autocomplete = _resolveComponent("el-autocomplete");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_upload_filled = _resolveComponent("upload-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_upload = _resolveComponent("el-upload");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
            modelValue: _unref(deptName),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(deptName) ? deptName.value = $event : null),
            clearable: "",
            placeholder: "请输入部门名称",
            "prefix-icon": "Search",
            style: {
              "margin-bottom": "2rem"
            }
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tree, {
            ref: "deptTreeRef",
            data: _unref(deptOptions),
            "expand-on-click-node": false,
            "filter-node-method": filterNode,
            props: {
              label: 'label',
              children: 'children'
            },
            "default-expand-all": "",
            "highlight-current": "",
            onNodeClick: handleNodeClick
          }, null, 8, ["data"])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
            ref: "queryRef",
            inline: true,
            model: _unref(queryParams),
            "label-width": "9.4rem"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "设备类型",
              prop: "deviceType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(queryParams).deviceType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).deviceType = $event),
                clearable: "",
                placeholder: "设备类型",
                style: {
                  "width": "14rem"
                },
                onChange: _cache[2] || (_cache[2] = $event => selectCurrentType())
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(devicesOptions), dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.dictValue,
                    label: dict.dictLabel,
                    value: dict.dictValue
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(queryParams).name = $event),
                clearable: "",
                placeholder: "请输入名称",
                style: {
                  "width": "14rem"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "关联设备",
              prop: "flatName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).flatName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(queryParams).flatName = $event),
                clearable: "",
                placeholder: "请输入名称",
                style: {
                  "width": "14rem"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "型号",
              prop: "model"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(queryParams).model = $event),
                clearable: "",
                placeholder: "型号",
                style: {
                  "width": "12rem"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: "Search",
                onClick: handleQuery,
                class: "satpro-button"
              }, {
                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode("搜索", -1)]))]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Refresh",
                onClick: resetQuery,
                class: "satpro-button"
              }, {
                default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("重置", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
            gutter: 10,
            class: "mb8"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Plus",
                plain: "",
                class: "satpro-button",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode("新增 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['drone:device:add']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(single),
                icon: "Edit",
                plain: "",
                class: "satpro-button",
                onClick: handleUpdate
              }, {
                default: _withCtx(() => [...(_cache[64] || (_cache[64] = [_createTextVNode("修改 ", -1)]))]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['drone:device:edit']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(multiple),
                icon: "Delete",
                plain: "",
                class: "satpro-button",
                onClick: handleDelete
              }, {
                default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode("删除 ", -1)]))]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['drone:device:remove']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Upload",
                plain: "",
                class: "satpro-button",
                onClick: handleImport
              }, {
                default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode("导入 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['drone:device:import']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Download",
                plain: "",
                class: "satpro-button",
                onClick: handleExport
              }, {
                default: _withCtx(() => [...(_cache[67] || (_cache[67] = [_createTextVNode("导出 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['drone:device:export']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Plus",
                plain: "",
                class: "satpro-button",
                onClick: goTree
              }, {
                default: _withCtx(() => [...(_cache[68] || (_cache[68] = [_createTextVNode("编辑自定义字段 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['drone:device:add']]])]),
              _: 1
            }), _createVNode(_component_right_toolbar, {
              showSearch: _unref(showSearch),
              "onUpdate:showSearch": _cache[6] || (_cache[6] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
              onQueryTable: getList
            }, null, 8, ["showSearch"])]),
            _: 1
          }), _cache[69] || (_cache[69] = _createElementVNode("div", {
            class: "menu-name"
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "设备管理")], -1)), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            ref: "devicetableRef",
            data: _unref(deviceList),
            "default-sort": _unref(defaultSort),
            onSelectionChange: handleSelectionChange,
            onSortChange: handleSortChange,
            "cell-style": {
              'padding-top': '1.2rem'
            },
            "header-cell-style": {
              background: 'transparent !important',
              color: '#FFFFFF',
              'text-align': 'center'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              align: "center",
              type: "selection",
              width: "50",
              selectable: selectable
            }), _createVNode(_component_el_table_column, {
              key: "id",
              align: "center",
              label: "设备编号",
              prop: "id",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending']
            }), _createVNode(_component_el_table_column, {
              key: "name",
              "show-overflow-tooltip": true,
              align: "center",
              label: "设备名称",
              prop: "name",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending']
            }), _createVNode(_component_el_table_column, {
              key: "model",
              "show-overflow-tooltip": true,
              align: "center",
              label: "型号",
              prop: "model"
            }), _createVNode(_component_el_table_column, {
              key: "deptName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "部门",
              prop: "deptName"
            }), _createVNode(_component_el_table_column, {
              key: "status",
              align: "center",
              label: "设备状态",
              prop: "status",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending']
            }, {
              default: _withCtx(scope => [_createVNode(_component_dict_tag, {
                options: _unref(device_status),
                value: scope.row.status
              }, null, 8, ["options", "value"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              key: "ownerUserName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "设备负责人",
              prop: "ownerUserName"
            }), _createVNode(_component_el_table_column, {
              key: "phoneNumber",
              "show-overflow-tooltip": true,
              align: "center",
              label: "联系方式",
              prop: "phoneNumber"
            }), _createVNode(_component_el_table_column, {
              align: "left",
              "class-name": "small-padding fixed-width",
              label: "操作",
              width: "240"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
                content: "详情",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "View",
                  type: "primary",
                  link: "",
                  onClick: $event => handleView(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:query']]])]),
                _: 2
              }, 1024), _createVNode(_component_el_tooltip, {
                content: "修改",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Edit",
                  type: "primary",
                  link: "",
                  onClick: $event => handleUpdate(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:edit']]])]),
                _: 2
              }, 1024), scope.row.deviceType !== '12' ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "删除",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Delete",
                  type: "primary",
                  link: "",
                  onClick: $event => handleDelete(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:remove']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.deviceType !== '12' ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                content: "说明书",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Document",
                  type: "primary",
                  link: "",
                  onClick: $event => handlePdfManager(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:import']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.deviceType === '0' || scope.row.deviceType === '1' || scope.row.deviceType === '2' || scope.row.deviceType === '3' || scope.row.deviceType === '4' || scope.row.deviceType === '11' || scope.row.deviceType === '13' ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 2,
                content: "设备关联",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Connection",
                  type: "primary",
                  link: "",
                  onClick: $event => handleDeviceFlatManager(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:edit']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.parentId !== undefined && scope.row.parentId !== null && (scope.row.deviceType === '4' || scope.row.deviceType === '5' || scope.row.deviceType === '6' || scope.row.deviceType === '7' || scope.row.deviceType === '8' || scope.row.deviceType === '9' || scope.row.deviceType === '10' || scope.row.deviceType === '15') ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 3,
                content: "关联载体信息",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Paperclip",
                  type: "primary",
                  link: "",
                  onClick: $event => deviceFlatManager(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:query']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), (scope.row.deviceType === '4' || scope.row.deviceType === '5' || scope.row.deviceType === '12') && scope.row.deviceName !== undefined && scope.row.deviceName !== null && scope.row.deviceName !== '' && scope.row.channelId !== undefined && scope.row.channelId !== null && scope.row.channelId !== '' ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 4,
                content: "播放",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "VideoPlay",
                  type: "primary",
                  link: "",
                  onClick: $event => handleDevicePlayManager(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:edit']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data", "default-sort"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
            limit: _unref(queryParams).pageSize,
            "onUpdate:limit": _cache[7] || (_cache[7] = $event => _unref(queryParams).pageSize = $event),
            page: _unref(queryParams).pageNum,
            "onUpdate:page": _cache[8] || (_cache[8] = $event => _unref(queryParams).pageNum = $event),
            total: _unref(total),
            onPagination: getList
          }, null, 8, ["limit", "page", "total"]), [[_vShow, _unref(total) > 0]])]),
          _: 1
        })]),
        _: 1
      }), _unref(open) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        title: _unref(title),
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => _isRef(open) ? open.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [...(_cache[72] || (_cache[72] = [_createTextVNode("确 定", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [...(_cache[73] || (_cache[73] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "deviceRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "18.5rem",
          class: "edit-file"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备名称",
                prop: "name"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).name,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).name = $event),
                  placeholder: "请输入设备名称",
                  maxlength: "30"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "归属部门",
                prop: "deptId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(form).deptId,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).deptId = $event),
                  data: _unref(deptOptions),
                  props: {
                    value: 'id',
                    label: 'label',
                    children: 'children'
                  },
                  "check-strictly": "",
                  clearable: "",
                  placeholder: "请选择归属部门",
                  "value-key": "id"
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 10
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "经纬度"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).longitude,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).longitude = $event),
                  placeholder: "经度",
                  maxlength: "30",
                  border: "",
                  style: {
                    "width": "14rem"
                  }
                }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
                  modelValue: _unref(form).latitude,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).latitude = $event),
                  placeholder: "纬度",
                  maxlength: "30",
                  style: {
                    "width": "14rem"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 2
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: "Location",
                onClick: openMapAddressDialog,
                class: "satpro-button"
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "高程（米）"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).highly,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).highly = $event),
                  placeholder: "高程",
                  maxlength: "30"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "UID",
                prop: "uid"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).uid,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).uid = $event),
                  placeholder: "请输入设备UID",
                  maxlength: "64"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备负责人",
                prop: "ownerUser"
              }, {
                default: _withCtx(() => [_createVNode(_component_tree_select, {
                  value: _unref(form).ownerUser,
                  "onUpdate:value": _cache[15] || (_cache[15] = $event => _unref(form).ownerUser = $event),
                  options: _unref(userList),
                  objMap: {
                    value: 'userId',
                    label: 'label',
                    children: 'children'
                  },
                  placeholder: "请选择"
                }, null, 8, ["value", "options"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "生产时间",
                prop: "productionTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(form).productionTime,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).productionTime = $event),
                  size: "small",
                  style: {
                    "width": "18rem",
                    "height": "3rem"
                  },
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "选择日期"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "到期时间",
                prop: "expirationTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(form).expirationTime,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).expirationTime = $event),
                  size: "small",
                  style: {
                    "width": "18rem",
                    "height": "3rem"
                  },
                  type: "date",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "选择日期"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "联系方式",
                prop: "phoneNumber"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).phoneNumber,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).phoneNumber = $event),
                  placeholder: "请输入联系方式",
                  maxlength: "11"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "型号",
                prop: "model"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).model,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).model = $event),
                  placeholder: "请输入设备型号",
                  maxlength: "30"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备编码",
                prop: "deviceName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).deviceName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(form).deviceName = $event),
                  placeholder: "请输入设备编码",
                  maxlength: "20"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备通道",
                prop: "channelId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).channelId,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _unref(form).channelId = $event),
                  placeholder: "请输入设备通道",
                  maxlength: "11"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "卫星主站",
                prop: "satelliteMasterStation"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).satelliteMasterStation,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(form).satelliteMasterStation = $event),
                  clearable: "",
                  placeholder: "请选择卫星主站"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(satelliteMasterStationOptions), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.value,
                      label: dict.label,
                      value: dict.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "卫通网关",
                prop: "satelliteGateway"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).satelliteGateway,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => _unref(form).satelliteGateway = $event),
                  placeholder: "请输入卫通网关",
                  maxlength: "64"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞控专线",
                prop: "flightControlLine"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).flightControlLine,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(form).flightControlLine = $event),
                  placeholder: "请输入飞控专线",
                  maxlength: "64"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "吊舱控制",
                prop: "podControl"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).podControl,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _unref(form).podControl = $event),
                  placeholder: "请输入吊舱控制",
                  maxlength: "64"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "吊舱视频",
                prop: "podVideo"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).podVideo,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _unref(form).podVideo = $event),
                  placeholder: "请输入吊舱视频",
                  maxlength: "64"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(form).fieldTemplateList && _unref(form).fieldTemplateList.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).fieldTemplateList, item => {
              return _openBlock(), _createBlock(_component_el_col, {
                key: item.field,
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: item.label,
                  prop: item.field
                }, {
                  default: _withCtx(() => [item.field === 'terminalId' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_autocomplete, {
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event,
                    "fetch-suggestions": querySearch,
                    "popper-class": "my-autocomplete",
                    placeholder: "请输入内容",
                    onSelect: handleSelect
                  }, {
                    default: _withCtx(({
                      item
                    }) => [_createElementVNode("div", _hoisted_7, _toDisplayString(item.terminalId), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(item.terminalName), 1)]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]), item.field === 'terminalId' && _unref(form)['terminalId'] ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    style: {
                      "background-color": "#1d5390",
                      "color": "#999999"
                    },
                    onClick: _cache[27] || (_cache[27] = $event => showTerminal(false))
                  }, {
                    default: _withCtx(() => [...(_cache[70] || (_cache[70] = [_createTextVNode("详细信息", -1)]))]),
                    _: 1
                  })) : _createCommentVNode("", true)])) : item.type === 1 ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event,
                    placeholder: "请输入内容"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])) : item.type === 2 ? (_openBlock(), _createBlock(_component_el_switch, {
                    key: 2,
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event,
                    "active-value": "true",
                    "inactive-value": "false",
                    "active-color": "#13ce66",
                    "inactive-color": "#0A447E"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])) : item.type === 3 ? (_openBlock(), _createBlock(_component_el_date_picker, {
                    key: 3,
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event,
                    type: "datetime",
                    placeholder: "选择日期时间"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), item.type === 4 ? (_openBlock(), _createBlock(_component_el_input_number, {
                    key: 4,
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])) : item.type === 5 ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 5,
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event,
                    placeholder: "请选择",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.map, tem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: tem.value,
                        label: tem.label,
                        value: tem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])) : item.type === 6 ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 6,
                    modelValue: _unref(form)[item.field],
                    "onUpdate:modelValue": $event => _unref(form)[item.field] = $event,
                    multiple: "",
                    placeholder: "请选择",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.map, tem => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: tem.value,
                        label: tem.label,
                        value: tem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1032, ["label", "prop"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })) : _createCommentVNode("", true), _cache[71] || (_cache[71] = _createElementVNode("br", {
            class: "clear",
            style: {
              "clear": "both"
            }
          }, null, -1)), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).remark,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => _unref(form).remark = $event),
                  type: "textarea",
                  placeholder: "请输入内容"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _unref(upload).title,
        modelValue: _unref(upload).open,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => _unref(upload).open = $event),
        width: "40rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitFileForm
        }, {
          default: _withCtx(() => [...(_cache[78] || (_cache[78] = [_createTextVNode("确 定", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[31] || (_cache[31] = $event => _unref(upload).open = false)
        }, {
          default: _withCtx(() => [...(_cache[79] || (_cache[79] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "uploadRef",
          action: _unref(upload).url + '?updateSupport=' + _unref(upload).updateSupport,
          "auto-upload": false,
          disabled: _unref(upload).isUploading,
          headers: _unref(upload).headers,
          limit: 1,
          "on-progress": handleFileUploadProgress,
          "on-success": handleFileSuccess,
          accept: ".xlsx, .xls",
          drag: ""
        }, {
          tip: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(upload).updateSupport,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => _unref(upload).updateSupport = $event)
          }, null, 8, ["modelValue"]), _cache[74] || (_cache[74] = _createTextVNode(" 是否更新已经存在的用户数据 ", -1))]), _cache[76] || (_cache[76] = _createElementVNode("span", null, "仅允许导入xls、xlsx格式文件。", -1)), _createVNode(_component_el_link, {
            underline: false,
            style: {
              "font-size": "1.2rem",
              "vertical-align": "baseline"
            },
            type: "primary",
            onClick: importTemplate
          }, {
            default: _withCtx(() => [...(_cache[75] || (_cache[75] = [_createTextVNode("下载模板 ", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_upload_filled)]),
            _: 1
          }), _cache[77] || (_cache[77] = _createElementVNode("div", {
            class: "el-upload__text"
          }, [_createTextVNode("将文件拖到此处，或"), _createElementVNode("em", null, "点击上传")], -1))]),
          _: 1
        }, 8, ["action", "disabled", "headers"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _unref(video).open ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 1,
        title: _unref(video).title,
        modelValue: _unref(video).open,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => _unref(video).open = $event),
        width: "90rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[34] || (_cache[34] = $event => closeDialog()),
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_unref(video).url === '' ? (_openBlock(), _createElementBlock("div", _hoisted_14, "暂无推流信息")) : _createCommentVNode("", true), _unref(video).url !== '' ? (_openBlock(), _createBlock(player, {
          key: 1,
          ref: "playerRef",
          url: _unref(video).url,
          fluent: "",
          autoplay: "",
          onDestroy: destroy
        }, null, 8, ["url"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["title", "modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _unref(titleview),
        modelValue: _unref(openview),
        "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => _isRef(openview) ? openview.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
          onClick: cancel1
        }, {
          default: _withCtx(() => [...(_cache[82] || (_cache[82] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "formviewRef",
          model: _unref(formview),
          "label-width": "18.5rem",
          class: "edit-file"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备名称",
                prop: "name"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).name), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "归属部门",
                prop: "deptName"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).deptName), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "经纬度"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).longitude) + "     " + _toDisplayString(_unref(formview).latitude), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "高程（米）"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).highly), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "UID",
                prop: "uid"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).uid), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_dict_tag, {
                  options: _unref(device_status),
                  value: _unref(formview).status
                }, null, 8, ["options", "value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备负责人",
                prop: "ownerUserName"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).ownerUserName), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "推流地址",
                prop: "ownerUserName"
              }, {
                default: _withCtx(() => [_unref(formview).pushPath ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  readonly: "",
                  modelValue: _unref(formview).pushPath,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => _unref(formview).pushPath = $event)
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "生产时间",
                prop: "productionTime"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).productionTime), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "到期时间",
                prop: "expirationTime"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).expirationTime), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "联系方式",
                prop: "phoneNumber"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).phoneNumber), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "型号",
                prop: "model"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).model), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备编码",
                prop: "deviceName"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).deviceName), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备通道",
                prop: "channelId"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).channelId), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "卫星主站",
                prop: "satelliteMasterStation"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).satelliteMasterStation), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "卫通网关",
                prop: "satelliteGateway"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).satelliteGateway), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "飞控专线",
                prop: "flightControlLine"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).flightControlLine), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "吊舱控制",
                prop: "podControl"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).podControl), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "吊舱视频",
                prop: "podVideo"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).podVideo), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(formview).fieldTemplateList && _unref(formview).fieldTemplateList.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formview).fieldTemplateList, item => {
              return _openBlock(), _createBlock(_component_el_col, {
                key: item.field,
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: item.label
                }, {
                  default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, [_createTextVNode(_toDisplayString(item.value) + " ", 1), item.field === 'terminalId' && item.value ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    style: {
                      "background-color": "#1d5390",
                      "color": "#999999"
                    },
                    onClick: $event => showTerminal(item.value)
                  }, {
                    default: _withCtx(() => [...(_cache[80] || (_cache[80] = [_createTextVNode("详细信息", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true)], 512), [[_vShow, item.type === 1 || item.type === 3 || item.type === 4]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(item.value ? "是" : "否"), 513), [[_vShow, item.type === 2]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(showItemLabel(item.type, item.map, item.value)), 513), [[_vShow, item.type === 5 || item.type === 6]])]),
                  _: 2
                }, 1032, ["label"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formview).remark), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[81] || (_cache[81] = _createElementVNode("br", {
            class: "clear",
            style: {
              "clear": "both"
            }
          }, null, -1))]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_unref(editfield), {
        ref: "editfieldRef"
      }, null, 512), _createVNode(_unref(instructions), {
        ref: "instructionsRef"
      }, null, 512), _createVNode(_unref(deviceflat), {
        ref: "deviceflatRef"
      }, null, 512), _unref(dialogMapAddress) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 2,
        "close-on-click-modal": false,
        title: "位置选择",
        width: "80rem",
        "append-to-body": "",
        center: "",
        modelValue: _unref(dialogMapAddress),
        "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => _isRef(dialogMapAddress) ? dialogMapAddress.value = $event : null),
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(tdtmap, {
          ref: "tdtmapRef",
          onSetPosition: setPosition,
          onSetAddress: setAddress,
          onCloseMapaddressDialog: closeMapaddressDialog
        }, null, 512)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: "天线数据",
        modelValue: _unref(sdpData).openData,
        "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => _unref(sdpData).openData = $event),
        width: "100rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        header: _withCtx(({
          close,
          titleId,
          titleClass
        }) => [_createElementVNode("div", _hoisted_16, [_createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, "天线数据", 10, _hoisted_17), _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "更新",
          placement: "top",
          "auto-close": 500
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            circle: "",
            icon: "Refresh",
            onClick: _cache[38] || (_cache[38] = $event => showTerminal('last')),
            class: "satpro-button update_button"
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[83] || (_cache[83] = _createElementVNode("div", {
          style: {
            "height": "1.6rem"
          }
        }, null, -1)), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.terminalName,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => _unref(sdpData).terminalData.terminalName = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "ID"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.terminalId,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => _unref(sdpData).terminalData.terminalId = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "经纬度"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.longitude,
                "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => _unref(sdpData).terminalData.longitude = $event),
                placeholder: "None",
                maxlength: "30",
                border: "",
                style: {
                  "width": "19rem"
                }
              }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.latitude,
                "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => _unref(sdpData).terminalData.latitude = $event),
                placeholder: "None",
                maxlength: "30",
                style: {
                  "width": "19rem"
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "端站网络"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.terminalNet,
                "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => _unref(sdpData).terminalData.terminalNet = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "ip地址"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.ipAdd,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => _unref(sdpData).terminalData.ipAdd = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "激活状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.activeStatus,
                "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => _unref(sdpData).terminalData.activeStatus = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "当前状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.currentStateDesc,
                "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => _unref(sdpData).terminalData.currentStateDesc = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发送速率"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.upByte,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => _unref(sdpData).terminalData.upByte = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "接收速率"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.downByte,
                "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => _unref(sdpData).terminalData.downByte = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "往返延迟时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.delayTime,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => _unref(sdpData).terminalData.delayTime = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "接收C/N"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.currentSnr,
                "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => _unref(sdpData).terminalData.currentSnr = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发送C/N"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.snrcal,
                "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => _unref(sdpData).terminalData.snrcal = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发送链路功放"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.txPower,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => _unref(sdpData).terminalData.txPower = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "当前波束ID"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.netWorkId,
                "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => _unref(sdpData).terminalData.netWorkId = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "波束名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.netWorkName,
                "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => _unref(sdpData).terminalData.netWorkName = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "天线标识"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.devname,
                "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => _unref(sdpData).terminalData.devname = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "设备状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.status,
                "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => _unref(sdpData).terminalData.status = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "在线状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.onlineflag,
                "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => _unref(sdpData).terminalData.onlineflag = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "AGC值"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.agc,
                "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => _unref(sdpData).terminalData.agc = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            style: {
              "margin-left": "5rem"
            },
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "速率更新时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                readonly: "",
                modelValue: _unref(sdpData).terminalData.rawIpUpDatetime,
                "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => _unref(sdpData).terminalData.rawIpUpDatetime = $event),
                placeholder: "None",
                maxlength: "30"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])])])]);
    };
  }
};